export const instructionData = [
  {
    img: '/images/light_mode.png',
    title: { en: 'Ensure good lighting', hi: 'अच्छी रोशनी सुनिश्चित करें' },
  },
  {
    img: '/images/cell_wifi.png',
    title: { en: 'Ensure a stable internet connection', hi: 'स्थिर इंटरनेट कनेक्शन सुनिश्चित करें' },
  },
  { img: '/images/eyeglasses.png', title: { en: 'Remove glasses', hi: 'चश्मा हटाएँ' } },
  { img: '/images/masks.png', title: { en: 'Remove mask', hi: 'मास्क हटाएँ' } },
  {
    img: '/images/background_replace.png',
    title: { en: 'Keep clean background', hi: 'बैकग्राउंड साफ़ रखें' },
  },
  // { img: '/images/ad_units.png', title: 'Follow on screen instructions' },
]
export const docInstructionData = [
  {
    img: '/images/light_mode.png',
    title: { en: 'Ensure good lighting', hi: 'अच्छी रोशनी सुनिश्चित करें' },
  },
  {
    img: '/images/cell_wifi.png',
    title: { en: 'Ensure a stable internet connection', hi: 'स्थिर इंटरनेट कनेक्शन सुनिश्चित करें' },
  },
  {
    img: '/images/card.png',
    title: {
      en: 'Keep the document at a fixed place before taking the photo',
      hi: 'फ़ोटो लेने से पहले डॉक्यूमेंट को एक स्थिर जगह पर रखें',
    },
  },
  // { img: '/images/ad_units.png', title: 'Follow on screen instructions' },
]
